// Angular
import {Component} from '@angular/core';
// Layout
import {OffcanvasOptions} from '../../../../core/_base/layout';
import {ItemService} from '../../../../provider/item.service';
import {MenuItemModel} from '../../../models/menu-item.model';

@Component({
  selector: 'kt-quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss']
})
export class QuickPanelComponent {
  items: MenuItemModel[] = [];

  constructor(public itemservice: ItemService) {
    this.itemservice.getItems();
    this.itemservice.items_change$.subscribe((datas) => {
      this.items = datas.filter(x => x.booking_system == 'onDemand');
      this.items.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    });
  }

  // Public properties
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'kt-quick-panel',
    closeBy: 'kt_quick_panel_close_btn',
    toggleBy: 'kt_quick_panel_toggler_btn'
  };
}
